import { Router } from '@angular/router';
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BarcodeScanner } from '@capacitor-community/barcode-scanner';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss'],
})
export class BarcodeComponent implements OnInit {
  @Output() ean = new EventEmitter<any>();
  @Output() scanning = new EventEmitter<any>();
  scanActive: boolean = false;
  constructor(private router: Router, private theme: ThemeService) {}

  ngOnInit() {
    this.startScanner();
  }

  async checkPermission() {
    return new Promise(async (resolve, reject) => {
      const status = await BarcodeScanner.checkPermission({ force: true });
      if (status.granted) {
        resolve(true);
      } else if (status.denied) {
        BarcodeScanner.openAppSettings();
        resolve(false);
      }
    });
  }

  async startScanner() {
    this.scanning.emit(true);
    const allowed = await this.checkPermission();

    if (allowed) {
      this.scanActive = true;
      BarcodeScanner.hideBackground();

      const result = await BarcodeScanner.startScan();

      if (result.hasContent) {
        this.scanActive = false;
        this.ean.emit(result.content);
        this.stopScanner();
        this.router.navigateByUrl(`/catalogo?ean=${result.content}`);
        //alert(result.content); //The QR content will come out here
        //Handle the data as your heart desires here
      } else {
        alert('NO DATA FOUND!');
      }
    } else {
      this.router.navigateByUrl(`/catalogo`).then(() => {
        window.location.reload();
      });
    }
  }

  stopScanner() {
    this.theme.setActiveTheme('default')
    BarcodeScanner.showBackground();
    BarcodeScanner.stopScan();
    this.scanActive = false;
    this.router.navigateByUrl(`/catalogo`).then(() => {
      window.location.reload();
    });
  }

  ionViewWillLeave() {
    BarcodeScanner.stopScan();
    this.scanActive = false;
  }
}
